"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckFilled = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var colour_1 = require("../theme/colour");
var size_1 = require("../theme/size");
function CheckFilled(_a) {
    var _b = _a.colour, colour = _b === void 0 ? colour_1.colours.purple[60] : _b, _c = _a.size, size = _c === void 0 ? size_1.IconSize.NORMAL : _c;
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: size, height: size, viewBox: "0 0 28 28", fill: "none" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M14 0.875C6.76238 0.875 0.875 6.76238 0.875 14C0.875 21.2376 6.76238 27.125 14 27.125C21.2376 27.125 27.125 21.2376 27.125 14C27.125 6.76238 21.2376 0.875 14 0.875ZM21.4304 10.312C21.557 10.4385 21.6203 10.5877 21.6203 10.7594C21.6203 10.9312 21.557 11.0803 21.4304 11.2069L12.2917 20.2642C12.1652 20.3908 12.016 20.454 11.8443 20.454C11.6725 20.454 11.5234 20.3908 11.3969 20.2642L6.56989 15.4101C6.44334 15.2836 6.38007 15.1344 6.38007 14.9627C6.38007 14.7909 6.44334 14.6418 6.56989 14.5152L7.79019 13.3221C7.91674 13.1955 8.06589 13.1322 8.23763 13.1322C8.40938 13.1322 8.55853 13.1955 8.68508 13.3221L11.8579 16.522L19.3424 9.09168C19.4689 8.96513 19.6181 8.90186 19.7898 8.90186C19.9615 8.90186 20.1107 8.96513 20.2372 9.09168L21.4304 10.312Z", fill: colour }) })));
}
exports.CheckFilled = CheckFilled;
